"use client";

import { useState } from "react";
import Link from "next/link";
import { useQuizResult } from "../hooks/use-quiz-result";

export default function WhyTrackHormones() {
  const [showMore, setShowMore] = useState(false);
  const result = useQuizResult();
  if (!result) return null;

  return (
    <div className="bg-[#e4eeff]">
      <div className="py-12 mx-6 bg-[#e4eeff]">
        <div className="title-32 text-[#232221] pb-5">
          {result.title}
        </div>

        <p
          className={`title-16 text-[#232221] overflow-hidden ${
            showMore ? "" : "line-clamp-[8] md:line-clamp-[12]"
          }`}
          dangerouslySetInnerHTML={{
            __html: result.content.join("<br/><br/>"),
          }}
        />

        <Link
          href="#"
          scroll={false}
          className="flex items-center cursor-pointer mt-2.5"
          onClick={(e) => {
            e.preventDefault();
            setShowMore(!showMore);
          }}
        >
          {showMore ? "See less" : "See more"}
          <img
            src="https://cdn.inito.com/rebrand_quiz/v1/others/downArrow.svg"
            alt="arrow"
            className={`ml-1.5 shrink-0 transition-transform duration-300 ${
              showMore ? "rotate-180" : ""
            }`}
          />
        </Link>
      </div>
    </div>
  );
}
